var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "contentElement",
      staticClass: "view-current-cohorts",
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Huidige partijen", icon: "magicon-inbox" } },
        [
          _c("ui-dropdown", {
            attrs: { options: _vm.quantityUnitOptions },
            model: {
              value: _vm.quantityUnit,
              callback: function ($$v) {
                _vm.quantityUnit = $$v
              },
              expression: "quantityUnit",
            },
          }),
          _c("ui-dropdown", {
            attrs: { empty: "Alle gebieden", options: _vm.parcelAreaOptions },
            model: {
              value: _vm.areaFilter,
              callback: function ($$v) {
                _vm.areaFilter = $$v
              },
              expression: "areaFilter",
            },
          }),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c(
            "ui-button",
            {
              attrs: { color: "highlight-1" },
              on: {
                click: function ($event) {
                  return _vm.exportExcel()
                },
              },
            },
            [_vm._v("Exporteren")]
          ),
        ],
        1
      ),
      _vm._l(_vm.$safe("parcels.items"), function (parcel) {
        return _vm.$safe(parcel, "sections.items").length
          ? _c("ui-panel", { key: parcel.id, staticClass: "lot" }, [
              _c(
                "div",
                { staticClass: "parcel-header-wrapper" },
                [
                  _c("h2", [
                    _vm._v(
                      "Perceel " +
                        _vm._s(parcel.parcelLocation.name) +
                        " " +
                        _vm._s(parcel.parcelLocation.number)
                    ),
                  ]),
                  _vm.parcelPredictionsByParcelId.get(parcel.id)
                    ? _c(
                        "ui-button",
                        {
                          attrs: { color: "highlight-1" },
                          on: {
                            click: function ($event) {
                              _vm.showPredictionModal(
                                _vm.parcelPredictionsByParcelId.get(parcel.id)
                              )
                            },
                          },
                        },
                        [_vm._v("Voorspellingen")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              parcel.alias
                ? _c("span", { staticClass: "subtitle" }, [
                    _vm._v("(Alias: " + _vm._s(parcel.alias) + ")"),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "sections-holder" },
                _vm._l(_vm.$safe(parcel, "sections.items"), function (section) {
                  return _c(
                    "div",
                    { key: section.id, staticClass: "section-wrapper" },
                    [
                      _c(
                        "ui-panel",
                        { staticClass: "section", attrs: { padding: false } },
                        [
                          _c(
                            "div",
                            { staticClass: "section-title" },
                            [
                              _c(
                                "ui-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$can("ROUTE_SECTIONS")
                                        ? "Vak detail"
                                        : "",
                                      expression:
                                        "$can('ROUTE_SECTIONS') ? 'Vak detail' : ''",
                                    },
                                  ],
                                  staticClass: "section-link",
                                  attrs: {
                                    disabled: !_vm.$can("ROUTE_SECTIONS"),
                                    to: {
                                      name: "section-detail",
                                      params: { id: section.id },
                                    },
                                  },
                                },
                                [_vm._v("Vak " + _vm._s(section.name))]
                              ),
                              _c("span", { staticClass: "cohort-link" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm._f("date")(
                                          _vm.$safe(
                                            section,
                                            "activeCohort.startDate"
                                          ),
                                          "LL"
                                        )
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "section-content" }, [
                            _c("table", [
                              _c("tr", [
                                _c("th", { staticStyle: { width: "50%" } }, [
                                  _vm._v("Gezaaid"),
                                ]),
                                _c("th", { staticStyle: { width: "50%" } }, [
                                  _vm._v("Gevist"),
                                ]),
                              ]),
                              _c(
                                "tr",
                                [
                                  _vm.quantityUnit === "BRUTO"
                                    ? [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.sowingTotal.brutoWeight"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.harvestTotal.brutoWeight"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon"),
                                          ]),
                                        ]),
                                      ]
                                    : _vm.quantityUnit === "NETTO"
                                    ? [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.sowingTotal.nettoWeight"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon"),
                                          ]),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.harvestTotal.nettoWeight"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon"),
                                          ]),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "tr",
                                [
                                  _vm.quantityUnit === "BRUTO"
                                    ? [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.sowingDensity.bruto"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon/ha"),
                                          ]),
                                        ]),
                                        _c("td"),
                                      ]
                                    : _vm.quantityUnit === "NETTO"
                                    ? [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm._f("number")(
                                                  _vm.$safe(
                                                    section,
                                                    "activeCohort.sowingDensity.netto"
                                                  )
                                                )
                                              )
                                            ) + " "
                                          ),
                                          _c("span", { staticClass: "unit" }, [
                                            _vm._v("mTon/ha"),
                                          ]),
                                        ]),
                                        _c("td"),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm._f("number")(
                                          _vm.$safe(
                                            section,
                                            "activeCohort.sowingTotal.bustal"
                                          )
                                        )
                                      )
                                    ) + " "
                                  ),
                                  _c("span", { staticClass: "unit" }, [
                                    _vm._v("Bustal"),
                                  ]),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm._f("number")(
                                          _vm.$safe(
                                            section,
                                            "activeCohort.harvestTotal.bustal"
                                          )
                                        )
                                      )
                                    ) + " "
                                  ),
                                  _c("span", { staticClass: "unit" }, [
                                    _vm._v("Bustal"),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ])
          : !_vm.loading && !_vm.fetchingParcels
          ? _c("div", { staticClass: "text-placeholder" }, [
              _vm._v(
                " Er zijn momenteel geen partijen om hier weer te geven. "
              ),
            ])
          : _vm._e()
      }),
      _vm.hasMoreParcels || (_vm.parcels == null && _vm.loading)
        ? _c("div", {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: true,
                expression: "true",
              },
            ],
            staticClass: "page-loader",
            staticStyle: { background: "none" },
          })
        : _vm._e(),
      _vm.parcels && _vm.parcels.totalCount === 0
        ? _c("span", { staticClass: "placeholder-full" }, [
            _vm._v(" Er zijn geen percelen gevonden "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }